<template>
    <div class="x-switch">
        <label class="x-label" style="margin-right: 8px">{{ label }}</label>
        <el-switch :value="value"
                   :active-text="activeText"
                   :inactive-text="inactiveText"
                   :disabled="disable"
                   @input="handleInput($event)"></el-switch>
    </div>
</template>

<style lang="scss">
.x-switch {
    margin-top: 24px;
}
</style>

<script>
export default {
    name: 'XSwitch',
    props: {
        label: {
            type: String,
            default: null,
        },
        value: {
            default: ''
        },
        disable: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        activeText: {
            type: String,
            default: '',
        },
        inactiveText: {
            type: String,
            default: '',
        },
        error: {
            default: null,
        }
    },
    data() {
        return {}
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
    }
}
</script>
